
import './costs.scss';

import CostDetailRows from './costDetailRows.js';
import CostTransactions from './costTransactions.js';

import { TabPanel, Item } from 'devextreme-react/tab-panel';

import { useCallback  } from "react";



export default function CostDetail(props) {


  const onTabSelectionChanged = useCallback((e) => {
    //notify("The button was clicked");
    ;
  }, []); 

 
  function renderDetailRowsTab() {
    return <CostDetailRows myKey = {props.data.key} status = {props.data.data.statoId} />;
  }

  function renderTransactionsTab() {
    return <CostTransactions myKey = {props.data.key} status = {props.data.data.statoId}  data = {props.data.data}/>;
  }

  return (

    <div>

      <div className="offer-title" align="left" > 
        <h2>Spesa n°  {props.data.data.numeroDoc} del {props.data.data.strDataDoc} -  {props.data.data.fornitore}</h2>      
      </div>

      <TabPanel    
        onSelectionChanged={onTabSelectionChanged}
      >
        <Item title="Dettaglio" render={renderDetailRowsTab} />
        <Item title="Pagamenti"  render={renderTransactionsTab}/>
      </TabPanel>

    </div>  
   
  )
};